import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "widget s20 px-6 py-7" }
const _hoisted_2 = { class: "s10 secondary-font text-grey-700 mb-4 text-right" }
const _hoisted_3 = { class: "s10 secondary-font text-red mb-4 text-right" }
const _hoisted_4 = { class: "s10 secondary-font text-grey-700 mb-4 text-right" }
const _hoisted_5 = { class: "s20 flex-center bg-color rounded-20 px-5 pt-4 pb-3" }
const _hoisted_6 = { class: "s10 secondary-font text-primary-color text-right" }
const _hoisted_7 = { key: 0 }

import { ref } from 'vue';
import { useMarketCartStore } from '@/stores/cart.store';
import { formatAmount } from '@/utils/formatters';
import { showAlert } from '@/utils/swal';
import ConfirmationModal from '@/components/ConfirmationModal.vue';
import { useRouter } from 'vue-router';


export default /*@__PURE__*/_defineComponent({
  __name: 'MarketCartInfos',
  props: {
    layout: { type: String, default: 'none' },
    hideButton: { type: Boolean, default: false },
},
  setup(__props) {

// @ts-expect-error raison: lib externe mal typée
const router = useRouter();
const cart = useMarketCartStore();
const props = __props;
const confirmationModalRef = ref<InstanceType<typeof ConfirmationModal> | null>(null);
const loadingEmptyCart = ref(false);
const errorMessageEmptyCart = ref('');
const loadingSubmitCart = ref(false);

async function doEmptyCart() {
    const confirm = await confirmationModalRef.value?.open("Panier", "Voulez-vous vraiment vider le panier ?");
    if (confirm) {
        loadingEmptyCart.value = true;
        try {
            cart.clearCart();
        } catch(error: any) {
            errorMessageEmptyCart.value = error.message || 'Une erreur est survenue lors de la requete au serveur. Veuillez réessayer.';
            await showAlert.error(errorMessageEmptyCart.value);
        } finally {
            loadingEmptyCart.value = false;
        }
    }
}

async function doSubmitCart() {
    loadingSubmitCart.value = true;
    await router.push(props.layout == 'frontoffice' ? '/front/market/checkout' : '/market/checkout');
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[3] || (_cache[3] = _createElementVNode("h3", { class: "secondary-font text-grey-700 mb-5" }, "Votre commande", -1)),
    _cache[4] || (_cache[4] = _createElementVNode("h5", { class: "s10 secondary-font text-grey-700 mb-4" }, "Sous-total", -1)),
    _createElementVNode("h5", _hoisted_2, _toDisplayString(_unref(formatAmount)(_unref(cart).getSousTotal)) + " F", 1),
    _cache[5] || (_cache[5] = _createElementVNode("h5", { class: "s10 secondary-font text-red mb-4" }, "Réduction", -1)),
    _createElementVNode("h5", _hoisted_3, "-" + _toDisplayString(_unref(formatAmount)(_unref(cart).getTotalPromotion)) + " F", 1),
    _cache[6] || (_cache[6] = _createElementVNode("h5", { class: "s10 secondary-font text-grey-700 mb-4" }, "TOTAL", -1)),
    _createElementVNode("h5", _hoisted_4, _toDisplayString(_unref(formatAmount)(_unref(cart).getTotal)) + " F", 1),
    _cache[7] || (_cache[7] = _createElementVNode("div", { class: "clear-both h-0" }, null, -1)),
    _createElementVNode("div", _hoisted_5, [
      _cache[0] || (_cache[0] = _createElementVNode("h5", { class: "s10 secondary-font text-primary-color" }, "Payer par mois", -1)),
      _createElementVNode("h5", _hoisted_6, _toDisplayString(_unref(formatAmount)(_unref(cart).getTotalEcheances)) + " F", 1)
    ]),
    _cache[8] || (_cache[8] = _createElementVNode("div", { class: "clear-both h-20" }, null, -1)),
    (!__props.hideButton)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createElementVNode("button", {
            class: _normalizeClass(["btn-ultra lg w-100", {'loading': loadingSubmitCart.value}]),
            onClick: doSubmitCart
          }, [...(_cache[1] || (_cache[1] = [
            _createElementVNode("div", { class: "btn-show" }, [
              _createElementVNode("span", null, " Valider mon panier")
            ], -1),
            _createElementVNode("div", { class: "btn-loading" }, [
              _createElementVNode("div", { class: "loader-dots" })
            ], -1)
          ]))], 2),
          _createElementVNode("button", {
            class: "btn-ultra danger lg w-100",
            onClick: doEmptyCart,
            style: {"margin-top":"20px"}
          }, [...(_cache[2] || (_cache[2] = [
            _createElementVNode("div", { class: "btn-show" }, [
              _createElementVNode("span", null, " Vider mon panier")
            ], -1),
            _createElementVNode("div", { class: "btn-loading" }, [
              _createElementVNode("div", { class: "loader-dots" })
            ], -1)
          ]))])
        ]))
      : _createCommentVNode("", true),
    _createVNode(ConfirmationModal, {
      ref_key: "confirmationModalRef",
      ref: confirmationModalRef
    }, null, 512)
  ]))
}
}

})